// extracted by mini-css-extract-plugin
module.exports = {"collaborator":"collaborator_collaborator__iE_8y","cursor":"collaborator_cursor__qGaf4","pointer":"collaborator_pointer__hG8JT","userinfo":"collaborator_userinfo__XXez1"};